import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { LanguageToggle } from '../ui/LanguageToggle';
import { Button } from '../ui/Button';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const {
    t
  } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    href: '#beneficios',
    label: t('nav.benefits')
  }, {
    href: '#proceso',
    label: t('nav.process')
  }, {
    href: '#doctor',
    label: t('nav.doctor')
  }, {
    href: '#testimonios',
    label: t('nav.testimonials')
  }, {
    href: '#faq',
    label: t('nav.faq')
  }];
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
    setIsMobileMenuOpen(false);
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-brand-cream/95 backdrop-blur-md border-b border-brand-stone/50 py-4' : 'bg-transparent py-6'}`} data-id="element-253">
      <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-254">
        <a href="#" className="flex items-baseline gap-1.5 group" data-id="element-255">
          <span className="text-2xl font-serif font-normal text-brand-dark transition-colors" data-id="element-256">
            Lipo Laser
          </span>
          <span className="text-[10px] font-medium tracking-[0.2em] uppercase text-brand-gold" data-id="element-257">
            Beverly Hills
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9" data-id="element-258">
          {navLinks.map(link => <a key={link.href} href={link.href} className="text-[11px] font-medium tracking-widest uppercase text-brand-dark/70 hover:text-brand-dark transition-colors" data-id="element-259">
              {link.label}
            </a>)}
        </nav>

        <div className="hidden lg:flex items-center gap-6" data-id="element-260">
          <LanguageToggle data-id="element-261" />
          <Button variant="luxury" size="sm" onClick={scrollToContact} data-id="element-262">
            {t('nav.cta')}
          </Button>
        </div>

        <div className="flex lg:hidden items-center gap-4" data-id="element-263">
          <LanguageToggle data-id="element-264" />
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-brand-dark p-2" aria-label="Menu" data-id="element-265">
            {isMobileMenuOpen ? <XIcon strokeWidth={1.5} data-id="element-266" /> : <MenuIcon strokeWidth={1.5} data-id="element-267" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-268">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.4,
        ease: [0.33, 1, 0.68, 1]
      }} className="lg:hidden bg-brand-cream border-t border-brand-stone overflow-hidden" data-id="element-269">
            <div className="container mx-auto px-6 py-8 flex flex-col gap-6" data-id="element-270">
              {navLinks.map(link => <a key={link.href} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-sm font-medium tracking-widest uppercase text-brand-dark py-2 border-b border-brand-stone/50" data-id="element-271">
                  {link.label}
                </a>)}
              <Button variant="luxury" className="mt-6 w-full" onClick={scrollToContact} data-id="element-272">
                {t('nav.cta')}
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}